export default ({ slot }) => window.googletag.destroySlots([slot]);
